<div class="k-input">
  <div class="k-input__wrapper">
    <input
      [type]="effectiveType()"
      [placeholder]="displayPlaceholder()"
      [value]="value()"
      [disabled]="disabled()"
      (input)="onInput($event)"
      (blur)="onBlur()"
      [class]="
        'k-input__field ' +
        (isError() ? 'k-input__field--error' : '') +
        (hasSuffixIcon() ? ' k-input__field--has-suffix' : '')
      " />

    @if (effectiveIcon()) {
      <span
        class="k-input__suffix-icon material-symbols-outlined"
        [class.k-input__suffix-icon--clickable]="isIconClickable()"
        (click)="onSuffixIconClick()">
        {{ effectiveIcon() }}
      </span>
    }
  </div>

  @if (currentErrorMessage()) {
    <div class="k-input__error">
      {{ currentErrorMessage()! | translate }}
    </div>
  }
</div>
